"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostViewSkeleton = void 0;
var react_1 = __importDefault(require("react"));
var Logo_1 = __importDefault(require("../Logo/Logo"));
var Skeleton_1 = __importDefault(require("../Skeleton/Skeleton"));
var PostMedia_1 = require("./PostMedia");
var PostViewSkeleton = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PostMedia_1.PostMedia, { skeleton: true, skeletonCount: 6 }),
        react_1.default.createElement("div", { className: "post-details" },
            react_1.default.createElement("div", { className: "top-bar" },
                react_1.default.createElement(Logo_1.default, null)),
            react_1.default.createElement(PostMedia_1.PostMedia, { mobileView: true, skeleton: true }),
            react_1.default.createElement("div", { className: "post-content" },
                react_1.default.createElement("div", { className: "post-metadata pv-skeleton" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, null)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, null)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, null))),
                react_1.default.createElement("div", { className: "section-nav pv-skeleton" },
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("a", null,
                                react_1.default.createElement(Skeleton_1.default, null))),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("a", null,
                                react_1.default.createElement(Skeleton_1.default, null))),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("a", null,
                                react_1.default.createElement(Skeleton_1.default, null))))),
                react_1.default.createElement("div", { className: "short-info pv-skeleton" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "60%" })),
                    react_1.default.createElement("div", { className: "post-map" },
                        react_1.default.createElement(Skeleton_1.default, { height: "11.25rem" })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "40%" })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "90%" })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "70%" }))),
                react_1.default.createElement("div", { className: "short-info pv-skeleton" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "60%" })),
                    react_1.default.createElement("div", { className: "post-map" },
                        react_1.default.createElement(Skeleton_1.default, { height: "11.25rem" })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "40%" })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "90%" })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Skeleton_1.default, { width: "70%" })))))));
};
exports.PostViewSkeleton = PostViewSkeleton;
